/* La Caza Cali — master light switch(es) (round 5.1)
 *
 * Binds every [data-lights-master-switch] on the page — the "Shop by
 * collection" header switch (sections/lacaza-collection-block.liquid),
 * the collection-page header switch (sections/main-collection-product-grid
 * .liquid / sections/main-collection-banner.liquid), AND the sticky mini
 * pill (snippets/lacaza-light-switch-mini.liquid, assets/lacaza-light
 * -mini.js) — to a single body[data-lights]="on"|"off" attribute. The
 * crossfade itself is pure CSS (assets/lacaza-uplift.css, the
 * body[data-lights="off"] .lp__img--on rule) — no per-card JS.
 *
 * A page can carry MORE THAN ONE bound switch at once (header + mini
 * pill). Clicking ANY bound switch updates every bound switch's visual
 * state together (aria-checked + data-state), not just the one clicked
 * — see applyStateToAll().
 *
 * Round 5.1: NO cross-page persistence. Every page starts ON, full stop
 * — this file no longer reads or writes any sessionStorage key for the
 * on/off state itself (an owner-reported bug: an OFF from the homepage's
 * pre-scroll dark start, or from a manual toggle on one page, was
 * carrying over and leaving collection/PDP pages stuck dark). The ONLY
 * exception is a page that has already set body[data-lights] earlier in
 * its OWN load before this file's DOMContentLoaded-time bind() runs —
 * today that is only the homepage's dark-start inline script (sections/
 * lacaza-collection-block.liquid), which is gated by its own separate
 * sessionStorage key (lacazaLightsAutoOn, owned by assets/lacaza-light
 * -home-intro.js) and unaffected by this change.
 *
 * Public API: window.LacazaLightMaster.setState(state, fireEvent, auto)
 * lets other scripts (assets/lacaza-light-home-intro.js) drive every
 * bound switch programmatically the same way a click does.
 *
 * Analytics:
 *   window.dataLayer.push({ event: 'light_master_toggle', to: 'off'|'on'[, auto: true] })
 */
(function () {
  'use strict';

  var bound = []; // { root, btn }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function applyStateToAll(state, fireEvent, auto) {
    bound.forEach(function (inst) {
      inst.root.dataset.state = state;
      if (inst.btn) inst.btn.setAttribute('aria-checked', state === 'on' ? 'true' : 'false');
      // Round 6.2: mirror onto the folded-knob button (sticky mini pill).
      inst.root.querySelectorAll('.lp__knob-fold').forEach(function (k) {
        k.setAttribute('aria-checked', state === 'on' ? 'true' : 'false');
      });
    });
    document.body.setAttribute('data-lights', state);
    if (fireEvent) {
      var payload = { event: 'light_master_toggle', to: state };
      if (auto) payload.auto = true;
      pushDataLayer(payload);
    }
  }

  function bind(root) {
    if (!root || root.dataset.lmBound === '1') return;
    root.dataset.lmBound = '1';
    root.classList.add('lp--js');

    var btn = root.querySelector('.lp__switch');
    if (!btn) return;

    bound.push({ root: root, btn: btn });

    // No sessionStorage read here (round 5.1) — only respect a value
    // body[data-lights] already carries from earlier in THIS page's own
    // load (the homepage dark-start inline script); otherwise every page
    // starts ON.
    var effective = document.body.getAttribute('data-lights');
    if (effective !== 'on' && effective !== 'off') {
      effective = 'on';
      document.body.setAttribute('data-lights', 'on');
    }
    root.dataset.state = effective;
    btn.setAttribute('aria-checked', effective === 'on' ? 'true' : 'false');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var next = root.dataset.state === 'off' ? 'on' : 'off';
      applyStateToAll(next, true, false);
    });
  }

  function init() {
    document.querySelectorAll('[data-lights-master-switch]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LacazaLightMaster = window.LacazaLightMaster || {};
  window.LacazaLightMaster.setState = function (state, fireEvent, auto) {
    if (state !== 'on' && state !== 'off') return;
    applyStateToAll(state, !!fireEvent, !!auto);
  };
})();
